import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getAccidentsInTreatment,
  getDeviationsByTypeCount,
  getEmptyExpiredAccidentsCount,
  getPendingAuthorizations,
} from "../../../actions/dashboard";
import CardContainer from "../../commons/dashboard/cardContainer";
import FullWidthCardDashboard from "../../commons/dashboard/fullWidthCardContainer";
import MyResponsiveBarByWRI from "../../commons/dashboard/myResponsiveBarByWRI";
import MyResponsivePie from "../../commons/dashboard/myResponsivePie";
import { StyledDashboardContainer } from "../../styled/dashboard";

const DashboardContainer = () => {
  const dispatch = useDispatch();

  const accidentsInTreatment = useSelector(
    (state) => state.dashboard.accidentsInTreatment,
  );
  const pendingAuthorizations = useSelector(
    (state) => state.dashboard.pendingAuthorizations,
  );
  const emptyExpiredAccidentsCount = useSelector(
    (state) => state.dashboard.emptyExpiredAccidentsCount,
  );
  const deviationsByTypeCount = useSelector(
    (state) => state.dashboard.deviationsByTypeCount,
  );

  return (
    <StyledDashboardContainer.CardsContainer>
      <StyledDashboardContainer.Title>
        ACTUALIDAD
      </StyledDashboardContainer.Title>
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="stretch"
        alignContent={"center"}
        spacing={2}
        marginBottom={2}
      >
        <CardContainer
          text="SINIESTROS EN TRATAMIENTO POR ART"
          component={<MyResponsivePie data={accidentsInTreatment.data} />}
          isFetching={accidentsInTreatment.isFetching}
          fetchData={() => dispatch(getAccidentsInTreatment())}
          didInvalidate={accidentsInTreatment.didInvalidate}
          name="accidentsInTreatment"
        />

        <CardContainer
          text="PEDIDOS DE AUTORIZACION PENDIENTE POR ART"
          component={<MyResponsivePie data={pendingAuthorizations.data} />}
          isFetching={pendingAuthorizations.isFetching}
          fetchData={() => dispatch(getPendingAuthorizations())}
          didInvalidate={pendingAuthorizations.didInvalidate}
          name="pendingAuthorizations"
        />

        <CardContainer
          text="SINIESTROS CON FECHA DE PRÓXIMO CONTROL VENCIDO O VACÍO POR ART"
          component={<MyResponsivePie data={emptyExpiredAccidentsCount.data} />}
          isFetching={emptyExpiredAccidentsCount.isFetching}
          fetchData={() => dispatch(getEmptyExpiredAccidentsCount())}
          didInvalidate={emptyExpiredAccidentsCount.didInvalidate}
          name="emptyExpiredAccidentsCount"
        />

      </Grid>
      <Grid container marginTop={2} justifyContent="center">

        <FullWidthCardDashboard
          text="CANTIDAD DE DESVÍOS EN SINIESTROS POR ART Y TIPO"
          component={
            <MyResponsiveBarByWRI
              data={deviationsByTypeCount.data}
              dataGroupAttribute="deviationsCount"
              indexByAttribute="art"
            />
          }
          isFetching={deviationsByTypeCount.isFetching}
          fetchData={() => dispatch(getDeviationsByTypeCount())}
          didInvalidate={deviationsByTypeCount.didInvalidate}
          name="deviationsByTypeCount"
        />
      </Grid>
    </StyledDashboardContainer.CardsContainer>
  );
};

export default DashboardContainer;
